// Audit + customer-facing endpoints — Packet W2a.
// Thin wrappers around `api` (the shared axios instance with
// `withCredentials: true`, defined in `../api.js`). Each function
// returns `response.data` exactly as today's inline call sites use it.
// No endpoint URL changes. No request/response shape changes.
// No customer-facing behavior changes.
import { api } from "../api";

// --- Static metadata ---------------------------------------------------------
export const getQuestions = async () => (await api.get("/audit/questions")).data;
export const getIntakeOptions = async () => (await api.get("/audit/intake-options")).data;
export const getLeakCategories = async () => (await api.get("/audit/leak-categories")).data;

// --- Session lifecycle ------------------------------------------------------
export const startAudit = async (payload = {}) =>
  (await api.post("/audit/start", payload)).data;

export const resumeSession = async (payload = {}) =>
  (await api.post("/audit/session/resume", payload)).data;

export const submitSnapshot = async (payload) =>
  (await api.post("/audit/snapshot", payload)).data;

export const submitAnswer = async (payload) =>
  (await api.post("/audit/answer", payload)).data;

export const submitAudit = async (payload) =>
  (await api.post("/audit/submit", payload)).data;

// --- Preview / Report -------------------------------------------------------
export const getPreview = async (sessionId) =>
  (await api.get(`/audit/preview/${sessionId}`)).data;

export const getReport = async (sessionId) =>
  (await api.get(`/audit/report/${sessionId}`)).data;

export const requestReportPdf = async (sessionId) =>
  (await api.post(`/audit/report/${sessionId}/pdf`)).data;
